import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { ParticipationsClientProvider } from '@/api/participations-client-context';
import { SupplierDetailScreen } from '@/routes/admin/suppliers/supplier-detail-screen';

// =============================================================================
// supplier-detail-route.tsx — Adaptateur routeur de l'écran A-04.
// =============================================================================
// Le SIRET est le path param d'URL (« /admin/suppliers/$siret ») — ressource
// d'URL, cohérent avec le contrat API (SIRET server-set côté back). Le composant
// de présentation reste testable hors routeur.
//
// AUTO-PORTE le DI seam du client « participations » (ParticipationsClientProvider) — la fiche compose
// le flag « campagne ouverte » (avertissement transfert MASTER, T4) par HTTP, comme le registre A-03.

const routeApi = getRouteApi('/admin/suppliers/$siret');

export function SupplierDetailRoute(): React.JSX.Element {
  const { siret } = routeApi.useParams();
  const navigate = useNavigate();

  const onBack = React.useCallback((): void => {
    void navigate({ to: '/admin/suppliers' });
  }, [navigate]);

  return (
    <ParticipationsClientProvider>
      <SupplierDetailScreen siret={siret} onBack={onBack} />
    </ParticipationsClientProvider>
  );
}
